import React from 'react';
import { BigPlayButton, Player } from 'video-react';
import { withRouter } from "react-router-dom";
import QAGrid from './QAGrid';
import Download from './Download';
import "../../node_modules/video-react/dist/video-react.css";

let ImportComponents = {
  QAGrid,
  Download,
}

class NewPage extends React.Component {
  render() {
    let filepath = this.props.location.pathname;
    let type = filepath.replace(/.*\./, '');
    let ComponentName = filepath.replace(/\//, '');
    //PDF處理
    if (type === "pdf") {
      return (
        <iframe
          title="test"
          height="100%"
          width="100%"
          src={"web/viewer.html?file=." + filepath + "#locale=zh-tw"}
          overflow="auto"
        />
      );
    }
    //MP4處理
    else if (type === "mp4") {
      return (
        <Player
          src={"." + filepath}
          poster="sony_poster.PNG"
        >
          <BigPlayButton position="center" />
        </Player>
      );
    }
    //HTML處理
    else if (type === "html") {
      return (
        <iframe
          title="test"
          height="100%"
          width="100%"
          src={"." + filepath}
          overflow="auto"
        />
      );
    }
    //自定義元件處理
    else {
      if (!ImportComponents[ComponentName]) {
        return <span>This page is not exist.</span>;
      }
      let Component = ImportComponents[ComponentName];
      return <Component />;
    }
  }
}

export default withRouter(NewPage);



// WEBPACK FOOTER //
// ./src/components/NewPage.js